import React from 'react';
import { GlassButton } from './GlassButton';
import styles from './GlassButtonGroup.module.css';

interface GlassButtonGroupProps {
  className?: string;
  discordHref?: string;
  signUpHref?: string;
  discordLabel?: string;
  signUpLabel?: string;
}

export const GlassButtonGroup: React.FC<GlassButtonGroupProps> = ({
  className = '',
  discordHref = 'https://discord.gg/ZtH6rZpa8y',
  signUpHref = 'https://app.rythm.fm/',
  discordLabel = 'Add to Discord',
  signUpLabel = 'Sign Up'
}) => {
  return (
    <div className={`${styles.buttonGroup} ${className}`}>
      <GlassButton 
        href={discordHref} 
        className={styles.discordButton}
        buttonType="primary"
      >
        {discordLabel}
      </GlassButton>
      
      <GlassButton 
        href={signUpHref} 
        className={styles.signUpButton}
        buttonType="secondary"
      >
        {signUpLabel}
      </GlassButton>
    </div>
  );
}; 